import { ITypeExecution } from 'ws-voice-infinity-global-module/lib/interfaces';
import { TypeService } from 'ws-voice-infinity-global-module/lib/services';

export enum TypeExecutionEnum {
    CREATED = 'CREATED',
    STARTED = 'STARTED',
    SUBJECT_CHANGED = 'SUBJECT_CHANGED',
    CONTENT_CHANGED = 'CONTENT_CHANGED',
    DECLINED = 'DECLINED',
    PASSED_TO_EXECUTION = 'PASSED_TO_EXECUTION',
    PASSED_TO_EXECUTION_AND_HIDE = 'PASSED_TO_EXECUTION_AND_HIDE',
    MODERATION_TIME_EXCEED = 'MODERATION_TIME_EXCEED',
    EXECUTION_FINISHED = 'EXECUTION_FINISHED',
    PROBLEM_SOLVED = 'PROBLEM_SOLVED',
    PROBLEM_CLOSED = 'PROBLEM_CLOSED',
    PROBLEM_SOLVED_AUTOMATICALLY = 'PROBLEM_SOLVED_AUTOMATICALLY',
    EXECUTION_TIME_EXCEED = 'EXECUTION_TIME_EXCEED',
    RETURNED_TO_EXECUTION = 'RETURNED_TO_EXECUTION',
    DELEGATED = 'DELEGATED',
    EXECUTION_DUE_DATE_EXTENDED = 'EXECUTION_DUE_DATE_EXTENDED',
    DELETED = 'DELETED',
    REVOKED = 'REVOKED',
    STARTED_AFTER_DECLINE = 'STARTED_AFTER_DECLINE',
    SOLVED_BY_CONTROLLER = 'SOLVED_BY_CONTROLLER',
    ANSWER_UPDATED_BY_CONTROLLER = 'ANSWER_UPDATED_BY_CONTROLLER',
    RELATE_MIGRATION = 'RELATE_MIGRATION',
    NOT_RELATE_MIGRATION = 'NOT_RELATE_MIGRATION',
    EXECUTOR_HIDE = 'EXECUTOR_HIDE',
    EXECUTOR_UNHIDE = 'EXECUTOR_UNHIDE',
    CLARIFIED = 'CLARIFIED',
    CONFIRMED = 'CONFIRMED', // Подтвержден
    CANCELLED_BY_EXECUTOR = 'CANCELLED_BY_EXECUTOR', // Отменен исполнителем
    CANCELLED_BY_AUTHOR = 'CANCELLED_BY_AUTHOR', // Отменен заявителем
    CANCELLED_AUTOMATICALLY = 'CANCELLED_AUTOMATICALLY', // Отменен по таймеру
    HELD = 'HELD', // Проведен
    COMPLETED = 'COMPLETED', // Завершен
    FINISHED = 'FINISHED', // Завершен.
    MEETING_DATE_CHANGED = 'MEETING_DATE_CHANGED', // Время онлайн-приема изменено.
}

/**
 * Типы исполнения
 */
const TYPE_EXECUTION: ITypeExecution = {
    CREATED: {
        name: 'Заявка создана',
        value: 'CREATED',
        type: 'default',
    },
    STARTED: {
        name: 'Заявка направлена на регистрацию',
        value: 'STARTED',
        type: 'default',
    },
    SUBJECT_CHANGED: {
        name: 'Изменен участник онлайн-приема',
        value: 'SUBJECT_CHANGED',
        type: 'default',
    },
    CONTENT_CHANGED: {
        name: '',
        value: 'CONTENT_CHANGED',
        type: 'default',
    },
    DECLINED: {
        name: 'Заявка отклонена',
        value: 'DECLINED',
        type: 'default',
    },
    PASSED_TO_EXECUTION: {
        name: 'Заявка зарегистрирована',
        value: 'PASSED_TO_EXECUTION',
        type: 'default',
    },
    PASSED_TO_EXECUTION_AND_HIDE: {
        name: 'Заявка зарегистрирована и скрыта',
        value: 'PASSED_TO_EXECUTION_AND_HIDE',
        type: 'default',
    },
    MODERATION_TIME_EXCEED: {
        name: 'Нарушен срок регистрации заявки',
        value: 'MODERATION_TIME_EXCEED',
        type: 'default',
    },
    EXECUTION_FINISHED: {
        name: 'Назначено время на онлайн-прием',
        value: 'EXECUTION_FINISHED',
        type: 'default',
    },
    PROBLEM_SOLVED: {
        name: 'Проблема решена',
        value: 'PROBLEM_SOLVED',
        type: 'success',
    },
    PROBLEM_CLOSED: {
        name: 'Проблема взята на контроль',
        value: 'PROBLEM_CLOSED',
        type: 'default',
    },
    PROBLEM_SOLVED_AUTOMATICALLY: {
        name: 'Проблема решена',
        value: 'PROBLEM_SOLVED_AUTOMATICALLY',
        type: 'success',
    },
    CLARIFIED: {
        name: 'Даны разъяснения по сообщению',
        value: 'CLARIFIED',
        type: 'success',
    },
    EXECUTION_TIME_EXCEED: {
        name: 'Нарушен срок ответа по заявке',
        value: 'EXECUTION_TIME_EXCEED',
        type: 'default',
    },
    RETURNED_TO_EXECUTION: {
        name: '',
        value: 'RETURNED_TO_EXECUTION',
        type: 'default',
    },
    DELEGATED: {
        name: 'Изменен исполнитель по заявке',
        value: 'DELEGATED',
        type: 'default',
    },
    EXECUTION_DUE_DATE_EXTENDED: {
        name: 'Продлен срок по заявке',
        value: 'EXECUTION_DUE_DATE_EXTENDED',
        type: 'default',
    },
    DELETED: {
        name: '',
        value: 'DELETED',
        type: 'default',
    },
    REVOKED: {
        name: '',
        value: 'REVOKED',
        type: 'default',
    },
    STARTED_AFTER_DECLINE: {
        name: '',
        value: 'STARTED_AFTER_DECLINE',
        type: 'default',
    },
    SOLVED_BY_CONTROLLER: {
        name: '',
        value: 'SOLVED_BY_CONTROLLER',
        type: 'success',
    },
    ANSWER_UPDATED_BY_CONTROLLER: {
        name: 'Приложены дополнительные сведения к ответу',
        value: 'ANSWER_UPDATED_BY_CONTROLLER',
        type: 'default',
    },
    RELATE_MIGRATION: {
        name: 'Заявка относится к вопросам миграции',
        value: 'RELATE_MIGRATION',
        type: 'default',
    },
    NOT_RELATE_MIGRATION: {
        name: 'Заявка не относится к вопросам миграции',
        value: 'NOT_RELATE_MIGRATION',
        type: 'default',
    },
    EXECUTOR_HIDE: {
        name: '',
        value: 'EXECUTOR_HIDE',
        type: 'default',
    },
    EXECUTOR_UNHIDE: {
        name: '',
        value: 'EXECUTOR_UNHIDE',
        type: 'default',
    },
    CONFIRMED: {
        name: 'Онлайн-прием подтвержден',
        value: 'CONFIRMED',
        type: 'default',
    },
    CANCELLED_BY_EXECUTOR: {
        name: 'Онлайн-прием отменен исполнителем',
        value: 'CANCELLED_BY_EXECUTOR',
        type: 'default',
    },
    CANCELLED_BY_AUTHOR: {
        name: 'Онлайн-прием отменен заявителем',
        value: 'CANCELLED_BY_AUTHOR',
        type: 'default',
    },
    CANCELLED_AUTOMATICALLY: {
        name: 'Онлайн-прием переведен в статус "Отменен заявителем"',
        value: 'CANCELLED_AUTOMATICALLY',
        type: 'default',
    },
    HELD: {
        name: 'Онлайн-прием состоялся',
        value: 'HELD',
        type: 'default',
    },
    COMPLETED: {
        name: '',
        value: 'COMPLETED',
        type: 'success',
    },
    FINISHED: {
        name: 'Назначено время на онлайн-прием',
        value: 'FINISHED',
        type: 'success',
    },
    MEETING_DATE_CHANGED: {
        name: 'Время онлайн-приема изменено',
        value: 'MEETING_DATE_CHANGED',
        type: 'default',
    },
};

export default TYPE_EXECUTION;

export const TypeExecutionType = TypeService.createEnum<TypeExecutionEnum>(TypeExecutionEnum, 'TypeExecutionEnum');
